import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_CONTACTBLOCK_NEW_RECORD, GET_CONTACTBLOCK_NEW_RECORD, GET_CONTACTBLOCK_BYID_NEW_RECORD} from '../actions';

import {
    createContactBlockItemNewRecordSuccess,
    createContactBlockItemNewRecordError,
    getContactBlockItemNewRecordSuccess,
    getContactBlockItemNewRecordError,
    getContactBlockItembyIdNewRecordSuccess,
    getContactBlockItembyIdNewRecordError
} from './actions';

const CREATE_NEW_RECORD_ERROR = "New record success.";

const createContactBlockNewRecordAsync = async (newRecord) => {

  try{
    if (newRecord.contactBlockId > 0)
    {
      const responseObject = await centralApiAxios.put("contact_blocks?id="+ newRecord.contactBlockId, newRecord);

      return {
      contactBlockItemRecord: responseObject.data,
      contactBlockId: responseObject.data.contactBlockId,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.contactBlockId > 0),
      message: ""
      };
    }
    else{
      const responseObject = await centralApiAxios.post("contact_blocks?id="+ newRecord.contactBlockId, newRecord);
      return {
      contactBlockItemRecord: responseObject.data,
      contactBlockId: responseObject.data.contactBlockId,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.contactBlockId > 0),
      message: ""
      };
    }

  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createContactBlockItemNewRecord({ payload }) {
  // eslint-disable-next-line
     const { history } = payload;
    try {
      const resultReturned = yield call(createContactBlockNewRecordAsync, payload.newRecord.contactBlockItemRecord);
      if (!resultReturned.message) {
        yield put(createContactBlockItemNewRecordSuccess(resultReturned));
        if (resultReturned.isNewsItemCreate)
        {
           // history.push("/app/vocabulary-overview/"+ resultReturned.vocabulary_id);
        }
        window.location.reload();
      } else {
        yield put(createContactBlockItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(createContactBlockItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

const getContactBlockItembyIdNewRecordAsync = async (payload) => {

  if (payload.contactBlockId == 0)
  {
    return {
      contactBlockItemRecord: undefined,
      contactBlockId: 0,
      message: ""
    };
  }
  try{
    const responseObject = await centralApiAxios.get(`/contact_blocks/${  payload.contactBlockId}?lcid=1033`);
    return {
    contactBlockItemRecord: responseObject.data,
    contactBlockId: responseObject.data.contactBlockId,
    message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
       contactBlockId: 5
    };
  }
};

function* getContactBlockItembyIdNewRecord({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(getContactBlockItembyIdNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(getContactBlockItembyIdNewRecordSuccess(resultReturned));
      } else {
        yield put(getContactBlockItembyIdNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(getContactBlockItembyIdNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

const getContactBlockItemNewRecordAsync = async (payload) => {

  if (payload.contactId == 0)
  {
    return {
      contactBlockItemRecord: undefined,
      contactBlockId: 0,
      message: ""
    };
  }
  try{
    const responseObject = await centralApiAxios.get(`/vocabularies/${  payload.contactId}?lcid=1033`);
    return {
    contactBlockItemRecord: responseObject.data,
    contactBlockId: responseObject.data.contactBlockId,
    message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* getContactBlockItemNewRecord({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(getContactBlockItemNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(getContactBlockItemNewRecordSuccess(resultReturned));
      } else {
        yield put(getContactBlockItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(getContactBlockItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}
// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_CONTACTBLOCK_NEW_RECORD, createContactBlockItemNewRecord);
}
// eslint-disable-next-line
export function* watchGetContactBlockItemNewRecord(newRecord) {
  yield takeEvery(GET_CONTACTBLOCK_NEW_RECORD, getContactBlockItemNewRecord);
}
// eslint-disable-next-line
export function* watchGetContactBlockItembyIdNewRecord(newRecord) {
  yield takeEvery(GET_CONTACTBLOCK_BYID_NEW_RECORD, getContactBlockItembyIdNewRecord);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetContactBlockItemNewRecord),
        fork(watchCreateRecords),
        fork(watchGetContactBlockItembyIdNewRecord)
    ]);
}
